// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__4Bg4c","content":"styles_content__pEXsi","title":"styles_title__M1mrM"};